import React from "react";
import i from "../../assets/images/appName/i.svg";
import d from "../../assets/images/appName/d.svg";
import k from "../../assets/images/appName/k.svg";
import h from "../../assets/images/appName/h.svg";
import a from "../../assets/images/appName/a.svg";
import b from "../../assets/images/appName/b.svg";
import {
  LogoContainer,
  LetterK,
  LetterI,
  LetterD,
  LetterH,
  LetterA,
  LetterB,
} from "./AppName.styles";

const AppName = () => {
  return (
    <LogoContainer>
      <LetterK src={k} alt="k letter" />
      <LetterI src={i} alt="i letter" />
      <LetterD src={d} alt="d letter" />
      <LetterH src={h} alt="h letter" />
      <LetterA src={a} alt="a letter" />
      <LetterB src={b} alt="b letter" />
    </LogoContainer>
  );
};

export default AppName;
